import { z } from 'zod';
export const FilterOption = z.object({
    label: z.string(),
    value: z.string(),
});
export const FilterOptions = z.array(FilterOption);
